<template>
    <div class="feeds" :class="{mobile:$vuetify.breakpoint.xs}">
        <h2 class="pl-4 mt-6">Лента заметок</h2>
        <!-- <v-tabs :vertical="$vuetify.breakpoint.smAndUp" :fixed-tabs="$vuetify.breakpoint.xsOnly" :value="feeds && feeds.indexOf(current_feed)">
            <div class="feed-wrap flex-center justify-center py-2">
                <template v-if="feeds && feeds.length">
                    <draggable 
                        v-if="$vuetify.breakpoint.smAndUp"
                        class="list-group"
                        :list="feeds" 
                        :animation="500"
                        @change="getOrderFeeds"
                        @start="dragging = true"
                        @end="dragging = false"
                    > 
                        <v-tab v-for="(feed, i) in feeds" :key="feed._id">     
                            <Feed
                                draggable="true"
                                @drop.native='dropNotice($event, feed)'
                                @dragover.prevent.native
                                @dragenter.prevent.native
                                :feed="feed"
                                @click.native="selectFeed(feed)"                 
                            />
                        </v-tab>
                    </draggable>
                    <v-tab v-else v-for="(feed, i) in feeds" :key="feed._id">
                        <Feed :feed="feed" @click.native="selectFeed(feed)"/>
                    </v-tab>
                </template>
                <div class="placeholder mr-2" v-else>Add a new feed: </div>
                <v-btn class="plus_button left plus_feed" @click="hidePlusFeeds" v-if="feeds_plus" fab dark small>
                    +
                </v-btn>
                <div v-else>
                    <v-layout align-center>
                        <v-text-field @keypress.ctrl="addFeedHandle" v-model="feeds_plus_name" label=""  placeholder="Enter feed name" required></v-text-field>
                        <v-btn icon @click="addFeedHandle">✓</v-btn>
                    </v-layout>
                </div>
            </div>
            <v-tab-item  v-for="(feed) in feeds" :key="feed._id" :transition="false" :reverse-transition="false">
                 <FeedBody :feed="feed"/>
            </v-tab-item>                          
        </v-tabs> -->
        <FeedBody/>
        <cookie-consent :message="message" :linkLabel="linkLabel" :buttonLabel="buttonLabel"/>     
    </div>
</template>

<script>
    // import draggable from 'vuedraggable'
	import FeedBody from './FeedBody'
    // import Feed from './Feed.vue'    
    import { mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'Feeds',
        components: {
            FeedBody,
            // Feed,
            // draggable
        },
        data() {
            return {
                feeds_plus: true,
                feeds_plus_name: '',
                dragging: false,
                message: "Этот веб-сайт использует файлы cookie, чтобы обеспечить вам наилучший опыт работы на нашем веб-сайте.",
                linkLabel: "Узнать подробнее",   
                buttonLabel: "Ясно"                        
            }
        },
        computed:{
            ...mapGetters(["feeds", "current_feed"]),                
        },
        methods: {
            ...mapActions(['addFeed','addNotice', 'editFeed','delNotice','saveOrderFeeds', 'moveNotice']),
            ...mapMutations(["SET_CURRENT_FEED"]),
            selectFeed(feed){
                this.SET_CURRENT_FEED(feed)
                this.feedBody = feed.body
                this.$router.replace(`/feeds/${this.current_feed.route_name}`)
            },
            hidePlusFeeds(){
                this.feeds_plus = false
            },
            addFeedHandle(){
                this.addFeed({name: this.feeds_plus_name, body: ""}).then(this.feedsRenameOk).then(() => {
                    const feeds_id = this.feeds.map(item => item._id)
                    this.saveOrderFeeds(feeds_id)
                })
            },         
            feedsRenameOk(){
                this.feeds_plus_name
                this.feeds_plus = true
                this.feeds_plus_name = ''
            }, 
            getOrderFeeds() {
                const feeds_id = this.feeds.map(item => item._id)
                this.saveOrderFeeds(feeds_id)
            },
            async dropNotice (evt, feed) {
                if(evt.dataTransfer.getData('dragNotice')) {
                    const dropNotice = JSON.parse(evt.dataTransfer.getData('dragNotice'))
                    this.moveNotice({
                        feed_from_id: this.current_feed._id,
                        notice_id: dropNotice._id,
                        feed_to_id: feed._id
                    })
                }
            },
        }, 
    }
</script>

<style lang="scss" scoped>
	.placeholder{
        color: #333;
        text-transform: uppercase;		
	}
    .plus_feed{
        background: #b9f3a6 !important;
        font-size: 22px;
        align-self: center;
        margin-right: 10px !important;
        box-shadow: none;
    }
</style>

<style lang="scss">
    .feeds{
        .v-slide-group__wrapper{
            background-color: var(--cl-bg2)
        }
        .v-tabs-slider-wrapper{
            color: #da9031;
        }
        .v-window-item{
            padding-left: 12px;
            padding-right: 12px;
        }
        &.mobile{
            .v-window-item{
                    padding: 0
            }            
            .notices-container{
                margin-top: 30px;
            }
        } 
    }
</style>